var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_296_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 296 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3917",
    "data-name": "\\uADF8\\uB8F9 3917",
    transform: "translate(-11917 3089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3916",
    "data-name": "\\uADF8\\uB8F9 3916",
    transform: "translate(11920 -3086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2906",
    "data-name": "\\uD328\\uC2A4 2906",
    d: "M499.328,160.633v.724h17.965v-.724a9,9,0,0,0-8.983-9.008h0A9,9,0,0,0,499.328,160.633Z",
    transform: "translate(-499.328 -143.357)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_211",
    "data-name": "\\uC120 211",
    x2: 5.33,
    y2: 5.395,
    transform: "translate(12.554 12.605)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_212",
    "data-name": "\\uC120 212",
    x1: 5.33,
    y2: 5.395,
    transform: "translate(0.081 12.605)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_141",
    "data-name": "\\uD0C0\\uC6D0 141",
    cx: 3.088,
    cy: 3.088,
    r: 3.088,
    transform: "translate(5.581 0)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser);
export default __webpack_public_path__ + "static/media/icoUser.12749376a20053dc444fffc9771af1d2.svg";
export { ForwardRef as ReactComponent };